import { parseBool } from '../utils';

const FLAG_PREFIX = 'REACT_APP_FF_';
const useFeatureFlags = () => {
    return Object.keys(process.env).reduce((acc, key) => {
        if (key.includes(FLAG_PREFIX)) {
            const newKey = key.replace(FLAG_PREFIX, '').toLowerCase();
            acc[newKey] = parseBool(process.env[key]);
        }
        return acc;
    }, {});
};

export default useFeatureFlags;
